
import { Component, Vue } from 'vue-property-decorator'
import { DxDeleteReason } from '@/models'
import { getDxDeleteReasons } from '@/components/diagnostics/diagnostics.service'

/** Matches SP rule: ReasonID = 5 requires OtherReason. */
const OTHER_REASON_ID = 5

@Component
export default class DxDeleteReasonModal extends Vue {
  public visible = false
  public loadingReasons = false
  public submitting = false
  public reasons: DxDeleteReason[] = []
  public selectedReasonId: number | null = null
  public otherReason = ''
  public attemptedSubmit = false

  get reasonOptions() {
    return (this.reasons || []).map(r => ({
      value: r.reasonID,
      text: r.reason
    }))
  }

  get isOther() {
    return this.selectedReasonId === OTHER_REASON_ID
  }

  get canConfirm() {
    if (!this.selectedReasonId || this.selectedReasonId <= 0) return false
    if (this.isOther && !this.otherReason.trim()) return false
    return true
  }

  get reasonState() {
    if (!this.attemptedSubmit) return null
    return this.selectedReasonId && this.selectedReasonId > 0 ? true : false
  }

  get otherState() {
    if (!this.attemptedSubmit || !this.isOther) return null
    return this.otherReason.trim() ? true : false
  }

  public async open() {
    this.resetForm()
    this.visible = true
    await this.loadReasons()
  }

  public close() {
    this.visible = false
  }

  public setSubmitting(value: boolean) {
    this.submitting = value
  }

  private resetForm() {
    this.selectedReasonId = null
    this.otherReason = ''
    this.attemptedSubmit = false
    this.submitting = false
  }

  private async loadReasons() {
    this.loadingReasons = true
    try {
      this.reasons = await getDxDeleteReasons()
    } catch (e) {
      this.reasons = []
      this.$swal.fire('Error', 'Could not load delete reasons.', 'error')
    } finally {
      this.loadingReasons = false
    }
  }

  public onConfirm() {
    this.attemptedSubmit = true
    if (!this.canConfirm) return
    this.$emit('confirm', {
      reasonId: this.selectedReasonId as number,
      otherReason: this.isOther ? this.otherReason.trim() : null
    })
  }

  public onHidden() {
    this.resetForm()
    this.$emit('cancel')
  }
}
